/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TableColumnSort,
  TableColumnSort$inboundSchema,
  TableColumnSort$Outbound,
  TableColumnSort$outboundSchema,
} from "./tablecolumnsort.js";

/**
 * Sort state for a table. Mirrors tanstack's config..
 */
export type TableSortingState = {
  /**
   * The columns to sort by.
   */
  state: Array<TableColumnSort>;
};

/** @internal */
export const TableSortingState$inboundSchema: z.ZodType<
  TableSortingState,
  z.ZodTypeDef,
  unknown
> = z.object({
  state: z.array(TableColumnSort$inboundSchema),
});
/** @internal */
export type TableSortingState$Outbound = {
  state: Array<TableColumnSort$Outbound>;
};

/** @internal */
export const TableSortingState$outboundSchema: z.ZodType<
  TableSortingState$Outbound,
  z.ZodTypeDef,
  TableSortingState
> = z.object({
  state: z.array(TableColumnSort$outboundSchema),
});

export function tableSortingStateToJSON(
  tableSortingState: TableSortingState,
): string {
  return JSON.stringify(
    TableSortingState$outboundSchema.parse(tableSortingState),
  );
}
export function tableSortingStateFromJSON(
  jsonString: string,
): SafeParseResult<TableSortingState, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TableSortingState$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TableSortingState' from JSON`,
  );
}
